// HOOKS
import { useEffect } from "react";
import useDebouncedSearch from "../../../../../hooks/other/useDebounedSearch.other.hook";

const DEFAULT_CLASSNAMES = {
  input:
    "font-ubuntuRegular focus:bg-primary px-2 shadow shadow-black focus:shadow-inner focus:shadow-black border-none bg-white focus:outline-none p-1 rounded border",
};

const CustomizableSearch = ({
  classNames = DEFAULT_CLASSNAMES,
  onSearch = () => {},
  search,
  otherProps,
}) => {
  const { debouncedValue, setDebouncedValue, setInputValue, inputValue } =
    useDebouncedSearch(700);
  useEffect(() => {
    if (search === inputValue) return;
    if (search === debouncedValue) return;
    if (debouncedValue || debouncedValue === "") {
      onSearch(debouncedValue);
    }
  }, [debouncedValue]);

  useEffect(() => {
    if (!search || search === inputValue) return;
    if (search === debouncedValue) return;
    setInputValue(search);
  }, [search]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <input
      type="search"
      autoComplete="off"
      placeholder="Search..."
      name="search"
      onChange={handleChange}
      value={inputValue}
      {...otherProps}
      className={classNames?.input || DEFAULT_CLASSNAMES.input}
    />
  );
};

export default CustomizableSearch;
